<template>
  <div>
    <v-row no-gutters class="pb-5">
      <v-col cols="6" sm="6">
        <div class="headline font-weight-black">Overview</div>
      </v-col>
      <v-col cols="6" sm="6">
        <div class="update text-right title" @click="update">
          <v-icon left color="#FF8F03">mdi-cached</v-icon>Update
        </div>
      </v-col>
    </v-row>
    <div class="font-weight-bold headline">
        
        <div v-if="reloading"><v-icon large color="green">mdi-access-point</v-icon>กำลังออนไลน์ 
          <v-progress-circular
                  color="primary"
                  indeterminate
          ></v-progress-circular> คน
        </div>
                
        <div v-else><v-icon large color="green">mdi-access-point</v-icon>กำลังออนไลน์ {{ totalLeaner.online }} คน</div>
    </div>
    <div>
      <otherGraph
        v-if="graphData"
        v-bind:data="graphData"
        v-bind:overallChartOptions="overallChartOptions"
      ></otherGraph>
      <div v-else style="min-height: 335px;">
        <v-progress-circular
          style="display: block; margin-left: auto; margin-right: auto; margin-top: 40px;"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
    
    <v-row no-gutters>
      <v-col align="center" sm="12" md="6" lg="6" cols="12">
        <div style="max-width:500px;">
          <apexchart
              type="donut"
              :options="deviceChartOptions"
              :series="piChartSeries"
          ></apexchart>
        </div>
      </v-col>
      <v-col sm="12" md="6" lg="6" cols="12">
        <v-card class="mx-5 mb-5 mt-3 stat-num stat-num-online">
          <v-card-title class="font-weight-bold">
            ออนไลน์สูงสุด
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-icon
                x-large
                color="white"
                >mdi-cast-education</v-icon>
              </v-col>
              <v-col align="right">
                <v-progress-circular
                  v-if="graphData==null"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                <div v-else class="display-1 white--text">
                  {{ maxOnline }} คน
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mx-5 mb-5 stat-num stat-num-joined">
          <v-card-title class="font-weight-bold">
            จำนวนผู้เข้าเรียน
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-icon
                x-large
                color="white">mdi-account-multiple</v-icon>
              </v-col>
              <v-col align="right">
                <v-progress-circular
                  v-if="reloading"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                <div v-else class="display-1 white--text">
                  {{totalLeaner.learner}} คน
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        
        <v-card class="mx-5 mb-5  stat-num stat-num-registered">
          <v-card-title class="font-weight-bold">
            จำนวนผู้ลงทะเบียน
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-icon
                x-large
                color="white">mdi-clipboard-account</v-icon>
              </v-col>
              <v-col align="right">
                <v-progress-circular
                  v-if="reloading"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                <div v-else class="display-1 white--text">
                  {{totalLeaner.register}} คน
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {
  getOnlineLearner,
  getTotalLearner
} from "@/service/course/livev2";
import otherGraph from "./dashboardGraph/otherGraph";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "dashboard",
  components: {
    otherGraph,
    apexchart: VueApexCharts,
  },
  props: {
    liveId: {
      type: String
    },
  },
  data: () => ({
    totalLeaner: {
      register: 0,
      learner: 0,
      online: 0,
      mail: 0
    },
    graphData: null,
    reloading: false,
    maxOnline: 0,

    //pi  chart
    piChartSeries: [0, 0],
    deviceChartOptions: {
      chart: {
          type: "donut",
      },
      legend: {
        show: true,
        position: "top",
        inverseOrder: true
      },
      labels: ['ขาดเรียน', 'เข้าเรียน'],
      colors: ['#A93B37', '#2B59C3'],
  plotOptions: {
    pie: {
      customScale: 1
    }
  }
    },

    // graph
    overallChartOptions: {
      chart: {
        stacked: false,
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true
        },
        toolbar: {
          autoSelected: "zoom"
        }
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 1
      },
      title: {
        text: "",
        align: "left"
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        }
      },
      fill: {
        // type: "gradient",
        // gradient: {
        //   shadeIntensity: 1,
        //   inverseColors: false,
        //   opacityFrom: 0.5,
        //   opacityTo: 0.5,
        //   stops: [0, 90, 100]
        // }
      },
      yaxis: {
        labels: {
          formatter: function(val) {
            return Math.floor(val);
          }
        },
        title: {
          text: "Number of Students"
        }
      },
      xaxis: {
        // type: "datetime"
        // title: {
        //   text: "Date"
        // }
        //  tickAmount: 5000,
        categories: []
      },
      tooltip: {
        x: {
          format: "dd/MM/yy"
        }
      }
    },
    overallSeries: [
      {
        name: "Num of Students",
        data: []
      }
    ],

  }),
  async mounted() {
    await this.reloadInfo();
    await this.getGraphOnlineLearner();
  },
  computed: {},
  methods: {
    async update() {
      await this.reloadInfo();
      await this.getGraphOnlineLearner();
    },
    async reloadInfo() {
      this.reloading = true
      let result = await getTotalLearner(this.liveId);
      this.reloading = false
      this.totalLeaner = result;
      this.piChartSeries = [result.register - result.learner, result.learner]
    },
    async getGraphOnlineLearner() {
      this.graphData = null;
      const graphData = (
        await getOnlineLearner(this.liveId)
      ).map(o => o.countOnline);

      const arr = [];
      this.maxOnline = 0;
      for (let i = 0; i <= graphData.length; i += 1) {
        arr.push(i.toString());

        if (graphData[i] > this.maxOnline){
          this.maxOnline = graphData[i]
        }
      }

      this.overallChartOptions.xaxis.title = {text: "Minute"}
      this.graphData = graphData;
    },
  }
};
</script>
<style  lang="scss" scoped>
.v-application--is-ltr
  .v-tabs--centered
  > .v-tabs-bar
  .v-tabs-bar__content
  > :last-child,
.v-application--is-ltr
  .v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tabs-bar__content
  > :last-child {
  margin-right: auto;
}
.update {
  color: #ff8f03;
  cursor: pointer;
}


.stat-num {
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 15px;
    transition: transform 0.3s ease-in-out;
}

.stat-num-online {
    //background-image: linear-gradient(rgba(#0779e4, 1), rgba(#0779e4, 0.7));
    background: rgba(#629460, 1);
    color: white;
}

.stat-num-joined {
    //background-image: linear-gradient(rgba(#9f4355, 1), rgba(#9f4355, 0.7));
    background: rgba(#445E93, 1);
    color: white;
}

.stat-num-registered {
    //background-image: linear-gradient(rgba(#482f4d, 1), rgba(#482f4d, 0.7));
    background: rgba(#7EB2DD, 1);
    color: white;
}
    

.stat-num:hover {
    /* box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19); */
    /* background-color: rgba(#0779e4, 0.4); */
    transform: scale(1.05, 1.05);
}
</style>